import Card from 'libs/card/Card'
import { useNavigate } from 'react-router-dom'
import MotionDiv from 'libs/motionDiv'
import Button from 'libs/button/Button'

import icons from 'assets/index.ts'

import { useSelector } from 'react-redux'
import { selectSelectedItem } from 'store/redux/navSlice'
import { useGetCountMaintenanceRequestQuery } from './Maintenance-request/maintenance-request/maintenance-request'
import { useGetMaintenanceOrdersCountQuery } from './maintenance-order/maintenance-order-endpoints/order.endpoints'
import FullPageLoader from 'libs/loader/FullPageLoader'
import useTabTitle from 'libs/hooks/useTabTitle'
import { useGetMachinesCountQuery } from './machines/machine-endpoints/machine.endpoints'
import { useGetMachineClassesCountQuery } from './machine-class/machine-class-endpoints/machineClass.endpoints'

interface CardDetail {
  icon: React.ReactNode
  title: string
  subtitle: string
  route: string
  disabled: boolean
}

const Maintenance = () => {
  useTabTitle('Maintenance')
  const plant = useSelector(selectSelectedItem)
  const { data: maintenanceRequestCount, isLoading: maintenanceRequestsCountLoading } =
    useGetCountMaintenanceRequestQuery(
      {
        plant_id: plant?.id,
      },
      {
        skip: !plant.id,
      },
    )
  const { data: maintenanceOrderCount, isLoading: maintenanceOrdersCountLoading } = useGetMaintenanceOrdersCountQuery(
    {
      plantId: plant?.id,
    },
    {
      skip: !plant.id,
    },
  )
  const { data: machinesCount, isLoading: isMachinesCountLoading } = useGetMachinesCountQuery(
    {
      plantId: plant?.id,
    },
    {
      skip: !plant.id,
    },
  )
  const { data: machineClassesCount, isLoading: isMachineClassesCountLoading } = useGetMachineClassesCountQuery(
    {
      plantId: plant?.id,
    },
    {
      skip: !plant.id,
    },
  )

  const navigate = useNavigate()

  const cardDetails = [
    {
      icon: <img src={icons.MaintenanceRequest} alt="" />,
      title: 'Maintenance Requests',
      subtitle: `${maintenanceRequestCount?.count ?? '-'} Maintenance Requests`,
      route: '/maintenance/maintenance-request',
    },
    {
      icon: <img src={icons.MaintenanceOrder} alt="" />,
      title: 'Maintenance Orders',
      subtitle: `${maintenanceOrderCount?.count ?? '-'} Maintenance Orders`,
      route: '/maintenance/maintenance-order',
    },
    {
      icon: <img src={icons.MachineLogo} alt="" />,
      title: 'Machines',
      subtitle: `${machinesCount?.count ?? '-'} Machines`,
      route: '/maintenance/machines',
    },
    {
      icon: <img src={icons.MachineClass} alt="" />,
      title: 'Machine Classes',
      subtitle: `${machineClassesCount?.count ?? '-'} Machine Classes`,
      route: '/maintenance/machine-classes',
    },
  ].filter(Boolean) as CardDetail[]

  return (
    <MotionDiv>
      <div className="h-full">
        <h1 className="h4-bold-black">Maintenance </h1>

        {maintenanceRequestsCountLoading ||
        maintenanceOrdersCountLoading ||
        isMachinesCountLoading ||
        isMachineClassesCountLoading ? (
          <div>
            <FullPageLoader />
          </div>
        ) : (
          <div className="grid h-full w-full grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 ">
            {cardDetails.map((card, index) => (
              <div key={`${index}_${card.title}`}>
                <Card
                  key={`${index}_${card.title}`}
                  disabled={card.disabled}
                  title={card?.title}
                  subtitle={card.subtitle}
                  leftIcon={card.icon}
                  rightCenterIcon={<Button color="primary"> View </Button>}
                  onClick={() => navigate(card.route)}
                  titleStyle="font-medium text-gray-800"
                />
              </div>
            ))}
          </div>
        )}
      </div>
    </MotionDiv>
  )
}

export default Maintenance
